import axios from "axios";
import { urlConfig } from "../../config/urlConfig";
import { GetExceptionsDetails, /*MetadataDownloads*/ } from "../../types/DocDistroCustomExceptionModel";
import { postCall } from "../httpService";

const baseUrl = process.env.REACT_APP_API_URL;
const getExceptionsDetailsUrl = urlConfig.GetExceptionDetails;

const apiClient = axios.create({
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

export const getExceptionDetailsData = async (params: GetExceptionsDetails) => {
    try {
        const response = await postCall(getExceptionsDetailsUrl, params);
        return response.data;
    } catch (error) {
        console.error('Error fetching exception details', error);
        throw error;
    }
};
